module.exports = __webpack_public_path__ + "static/media/smart-fit-main.68b9006b.png";